module.exports = __webpack_public_path__ + "static/img/memberLFW.a110a5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/investTeam/memberLFW.png
// module id = itfV
// module chunks = 0